import { promiseImpl } from 'ejs';
import React, { useState } from 'react';
import { Document, Page } from 'react-pdf';
import { pdfjs } from 'react-pdf';
import { Intent, Classes,Popover,Menu,MenuDivider,MenuItem } from "@blueprintjs/core";
import { Button,Radio,RadioGroup, Card, Elevation,Slider, Overlay,H4,Icon } from "@blueprintjs/core";
import {Toaster, Position} from "@blueprintjs/core";
import  {MSG_VISIO} from "../MessagesVisio.js"
const toaster=Toaster.create({
  className: "my-toaster",
  position: Position.TOP_RIGHT
});

/*const options = {
  cMapUrl: 'cmaps/',
  cMapPacked: true,
};*/
export default class CardFonctionsIndividuelles extends React.Component  <{}> {
  msg_visio=MSG_VISIO;
  state = {
    intercommunication:-1,
    ecoutediscrete:-1,
    force_width:680,
    select_matiere_id:"-1",
    choix_matiere:false,
    frameurl:undefined,
    eleve_selected_ecoutediscrete:-1,
    eleve_selected_intercommunication:-1,
    datamatieres:this.props.datamatieres
  }  
  
  constructor(props) {
        super(props);
      }
  componentDidMount () {     
    //JSON.stringify(testObject)
    
    var st=localStorage.getItem("select_matiere_id");
    if(st!="")this.setState({select_matiere_id:st}); 
    console.log(this.props.selected_classe_item)
    this.setState({datamatieres:this.props.datamatieres})
  }
 
  componentDidUpdate(prevProps, prevState) {
    if(this.props.frameurl!=this.state.frameurl)this.setState({frameurl:this.props.frameurl});
    if(this.props.datamatieres!=this.state.datamatieres)this.setState({datamatieres:this.props.datamatieres});
    if(this.props.eleve_selected_intercommunication!=this.state.eleve_selected_intercommunication)this.setState({eleve_selected_intercommunication:this.props.eleve_selected_intercommunication});
    if(this.props.eleve_selected_ecoutediscrete!=this.state.eleve_selected_ecoutediscrete)this.setState({eleve_selected_ecoutediscrete:this.props.eleve_selected_ecoutediscrete});
    //localStorage.setItem("intercommunication",JSON.stringify(this.state.intercommunication));
    //localStorage.setItem("ecoutediscrete",JSON.stringify(this.state.ecoutediscrete));
  }
  
 
  handletaille=()=>{
    this.setState({force_width:"100%"});
    this.setState({showcontenu:"block"});
    this.setState({elargir:"arrow-left"});
  }
  handleSelectMatiere =(ev)=>{
    //console.log(ev);
    this.setState({select_matiere_id:ev.currentTarget.value});
    localStorage.setItem("select_matiere_id",ev.currentTarget.value);
    this.props.ForcerMatiere(this.props.selected_classe_id,ev.currentTarget.value);
  }
  handleMettreEnEnregistrement=(classeid,groupe_nom)=>{
   
    var obj=[];
    var etat=this.isActif(this.state.recordaudio,groupe_nom);
    etat=!etat;
    if(etat)
    {
     this.state.recordaudio.groupes.map((it)=>obj.push(it));
      obj.push(groupe_nom);
    }
    else
    {
     this.state.recordaudio.groupes.map((it)=>{ if (it!=groupe_nom)obj.push(it);});
    }
    //var etat2=obj.length>0;
    var objrecordaudio=this.state.recordaudio;
    objrecordaudio.groupes=obj;
    //var st={selected:etat2,groupes:obj}
    //this.setState({recordaudio:st});
    this.props.MettreEnEnregistrement(classeid,etat,groupe_nom,objrecordaudio);
   }
  handleMettreEnConference=(classeid,groupe_nom)=>{
   
   var obj=[];
   var etat=this.isActif(this.state.conference,groupe_nom);
   etat=!etat;
   if(etat)
   {
    this.state.conference.groupes.map((it)=>obj.push(it));
     obj.push(groupe_nom);
   }
   else
   {
    this.state.conference.groupes.map((it)=>{ if (it!=groupe_nom)obj.push(it);});
   }
   //var etat2=obj.length>0;
   var objconference=this.state.conference;
   objconference.groupes=obj;
   //var st={selected:etat2,groupes:obj}
   this.props.MettreEnConference(classeid,etat,groupe_nom,objconference);
   //this.setState({conference:objconf});
  }
  
  isActifRGB=(obj_fonction,groupe_nom)=>{
    var ret="rgba(255,255,255,1)";
    if(obj_fonction==undefined) return ret;
    obj_fonction.groupes.map((it)=>
    {
      if(it==groupe_nom) ret="rgba(88,201,255,0.5)";
    });
    return ret;
  }
  isActif=(obj_fonction,groupe_nom)=>{
    var ret=false;
    if(obj_fonction==undefined) return ret;
    obj_fonction.groupes.map((it)=>
    {
      if(it==groupe_nom) ret=true;
    });
    return ret;
  }
  showRedirige = (url) => {
    if(url!=undefined)
    {
      console.log("url:"+url)
      //window.location=url;
      const varstyle="style='width:100%;height:800px;display:block;position: relative;border: 0;z-index:1'";
      return <div style={{width:'100%',height:'100%',display:'block',marginTop:5, position: 'relative',border: '0'}}  dangerouslySetInnerHTML={{ __html: "<iframe id='iframe_visio'" +varstyle+"  src='"+url+"' />"}} />;
    }
  
  }
   render() {
    
    

    return(
     <div>
     <Card style={{width:this.state.force_width,marginLeft:4,marginTop:0, objectFit:'contain'}} interactive={false} elevation={Elevation.TWO}>
     <div>
       <H4>Fonctions individuelles</H4>
       <Button disabled={this.state.ecoutediscrete>-1} intent={this.state.intercommunication>-1 ?Intent.DANGER:Intent.PRIMARY} icon="headset" onClick={(ev)=>{if(this.state.intercommunication>-1){this.setState({intercommunication:-1});this.props.MettreEnIntercom(false);}else{this.setState({intercommunication:0});this.props.MettreEnIntercom(true);}}}>Intercommunication</Button>
       <Button style={{marginLeft:10}} disabled={this.state.intercommunication>-1} intent={this.state.ecoutediscrete>-1 ?Intent.DANGER:Intent.PRIMARY}  icon="flow-linear" onClick={(ev)=>{if(this.state.ecoutediscrete>-1){this.setState({ecoutediscrete:-1});this.props.MettreEnEcouteDiscrete(false);}else{this.setState({ecoutediscrete:0});this.props.MettreEnEcouteDiscrete(true);}}}>Ecoute</Button>
     </div>
     {this.showRedirige(this.state.frameurl)}
     </Card>
     
     </div>
     
     );
}
}

